import { ADMIN_MODAL_TYPE, useModalStore } from '@modal'
import { Modal } from '@ui'
import moment from 'moment'
import { CalendarEventDefaultData } from './CreateAppointment'

type Props = {
  defaultData?: CalendarEventDefaultData
  onClose: () => void
}

const appointmentDetails = (defaultData: CalendarEventDefaultData) => {
  return [
    {
      label: `Doctor's Name`,
      value: defaultData?.meta?.doctorName
    },
    {
      label: 'Date & Time',
      value: `${moment(defaultData?.meta?.attributes?.appointment_at).format('DDDD, MMMM DD')} ${moment(defaultData?.meta?.attributes?.start_time).format('hh:mm a')} - ${moment(defaultData?.meta?.attributes?.end_time).format('hh:mm a')}`
    },
    {
      label: 'Appointment Type',
      value: defaultData?.title
    },
    {
      label: 'Patient',
      value: defaultData?.meta?.patientName
    }
  ]
}

export const CalendarDetails = ({ defaultData, onClose }: Props) => {
  const { openModal } = useModalStore()
  const onDelete = () => {
    openModal(ADMIN_MODAL_TYPE.CANCEL_APPOINTMENT, { id: defaultData?.id || '', showStaff: true })
  }

  const onEdit = () => {
    openModal(ADMIN_MODAL_TYPE.CREATE_APPOINTMENT, { defaultData, id: defaultData?.id || '' })
  }

  return (
    <Modal onClose={onClose} onDelete={onDelete} onEdit={onEdit} title="Appointment Details">
      <div className="w-full min-w-0 max-w-[550px] p-10 flex flex-col gap-7 ">
        {defaultData &&
          appointmentDetails(defaultData).map(item => (
            <div className="grid grid-cols-2 gap-2" key={item.label}>
              <div className="text-sm font-medium text-gray-500">{item.label}</div>
              <div className="text-sm capitalize text-[#1A1A1A]">{item.value}</div>
            </div>
          ))}
      </div>
    </Modal>
  )
}
